import React from 'react'

import Formatacao from '@/app/util/formatacao'

export const templates = {

    VALOR_TEMPLATE : (rowData) => {
        return <span className="center">{Formatacao.currency(rowData.valor)}</span>
    },

    DATA_LOCALDATE_TEMPLATE  : (rowData) => {
        return <span className="center">{Formatacao.localDate(rowData.data)}</span>
    }
}